import { VarDefinition } from "@swivl-mono/types";
import { Button, ButtonVariant, Input, OldPanel } from "@swivl-mono/ui";
import { useState } from "react";

interface Props {
  variable: VarDefinition;
  updateVar: (v: VarDefinition) => void;
  deleteVar: (v: VarDefinition) => void;
}

export function AdminVariablesEditorVariable(props: Props) {
  const { updateVar } = props;
  const [variable, setVariable] = useState<VarDefinition>(props.variable);
  return (
    <OldPanel
      className="mb-3"
      header={
        <>
          {variable.type} - {variable.displayName}
        </>
      }
      headerRight={<>{variable.varKey}</>}
    >
      <div className="flex flex-col gap-2">
        <Input
          label="Key"
          value={variable.key}
          onChange={(event) => {
            const updated: VarDefinition = { ...variable, key: event.target.value as any };
            setVariable(updated);
            updateVar(updated);
          }}
          containerClassName="w-full"
        />

        <Input
          label="Display Name"
          value={variable.displayName}
          id="displayName"
          name="displayName"
          onChange={(event) => {
            const updated: VarDefinition = { ...variable, displayName: event.target.value as any };
            setVariable(updated);
            updateVar(updated);
          }}
          containerClassName="w-full"
        />

        <Input
          label="Description"
          value={variable.description}
          name="description"
          id="description"
          onChange={(event) => {
            const updated: VarDefinition = { ...variable, description: event.target.value as any };
            setVariable(updated);
            updateVar(updated);
          }}
          containerClassName="w-full"
        />

        <Input
          label="Default Value"
          value={variable.defaultValue}
          name="defaultValue"
          id="defaultValue"
          onChange={(event) => {
            const updated: VarDefinition = { ...variable, defaultValue: event.target.value as any };
            setVariable(updated);
            updateVar(updated);
          }}
          containerClassName="w-full"
        />

        {/* {variable.type === VarType.Location && (<>
          <label>Default Value</label>
          <RadioButtons 
          value={variable.limitTo} 
            options = {[{label:'Location', value:LimitToLocationType.LOCATION},{label:'Group', value:LimitToLocationType.GROUP},{label:'Org', value:LimitToLocationType.ORG}]}
          inline={true} 
    onOptionSelected={(option:RadioButtonItem) => {
      const updated:VarDefinition = { ...variable, limitTo: option.value as any };
      setVariable(updated);
      updateVar(updated);
    }} />  
        </>)} */}

        <Button variant={ButtonVariant.GHOST} onClick={() => props.deleteVar(variable)}>
          Delete Variable
        </Button>
      </div>
    </OldPanel>
  );
}
